import {IPaymentTransaction} from "@connox/typescript-library/types/checkout/requestHandlers/CheckoutRequestHandler";
import window from "../../components/lib/WindowExtended";
import {PaymentController} from "../../components/lib/payments/PaymentController";
import {Checkout} from "@connox/typescript-library";
import {PayPalInfoType} from "./paypalTypes";
import {FUNDING_SOURCE} from "@paypal/paypal-js";

type OnApproveInfoType = {
  lastPaymentTransaction: IPaymentTransaction | null;
  lastWorkingCall: string | null;
};

export const onPayPalApprove = async (checkout: Checkout, paypalInfo: PayPalInfoType) => {
  const info: OnApproveInfoType = {
    lastPaymentTransaction: null,
    lastWorkingCall: null,
  };
  try {
    if (window.annotationTextArea !== (checkout.customerRemark ?? undefined)) {
      await checkout.put({customerRemark: window.annotationTextArea});
      info.lastPaymentTransaction = checkout.paymentTransaction;
      info.lastWorkingCall = "pplCustomerRemarkPut";
      await new Promise((resolve) => setTimeout(resolve, 400));
    }
    info.lastPaymentTransaction = await PaymentController.initPayment();
    info.lastWorkingCall = "pplInitPayment";
    await new Promise((resolve) => setTimeout(resolve, 400));
    info.lastPaymentTransaction = await PaymentController.authorizePayment(paypalInfo.nonce);
    info.lastWorkingCall = "pplAuttPayment";
    await new Promise((resolve) => setTimeout(resolve, 400));
    await checkout.purchase();
  } catch (err) {
    (err as Error & {info: OnApproveInfoType}).info = info;
    (err as Error & {paymentSource: FUNDING_SOURCE}).paymentSource = paypalInfo.paymentSource;
    throw err;
  }
};
